enum System {
  WINDOWS = 'Windows',
  LINUX = 'Linux',
}

export { System };
